module.exports = {
  BLACK_AND_WHITE: "bw",
  PERFORMER_MODE: "PERFORMER_MODE",
  JAMMER_MODE: "JAMMER_MODE",
  BROADCASTER_MODE: "BROADCASTER_MODE",
  PERFORMER_AND_BROADCASTER: "PERFORMER_AND_BROADCASTER",
  PERFORMER_WITH_BROADCASTER: "PERFORMER_WITH_BROADCASTER"
}